import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Row, Col, Form, Input, Button, Typography, Card } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { forgotPasswordAPI } from "../Login/LoginApi";
import { startTransition } from "react";
import { useState, useEffect } from "react";
import { resetForgotPasswordState } from "./LoginSlice";

function ForgotPassword() {
  const { Title } = Typography;
  const loading = useSelector((state) => state.GlobalSpinner.loader);
  const resetPasswordState = useSelector(
    (state) => state.login.forgotPasswordState
  );
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const HandleSubmit = async () => {
    try {
      const formData = await form.validateFields();
      setSubmitted(true);
      dispatch(forgotPasswordAPI(formData));
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
    }
  };

  const handleToLogin = () => {
    dispatch(resetForgotPasswordState());
    startTransition(() => {
      navigate(`/homepage`);
    });
  };

  useEffect(() => {
    dispatch(resetForgotPasswordState());
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: "400px",
          borderRadius: "16px",
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          border: "none",
        }}
        bodyStyle={{
          padding: "40px 30px",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <Title
            level={2}
            style={{
              margin: 0,
              color: "#1a1a1a",
              fontSize: "28px",
              fontWeight: "600",
            }}
          >
            Forgot your password?
          </Title>
          {!submitted && (
            <p
              style={{
                color: "#666",
                marginTop: "12px",
                marginBottom: 0,
                fontSize: "15px",
                lineHeight: "1.5",
              }}
            >
              Enter your email address and we'll send you instructions to reset
              your password.
            </p>
          )}
        </div>

        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          {resetPasswordState === true ? (
            <>
              <div
                style={{
                  padding: "16px",
                  backgroundColor: "#f6ffed",
                  border: "1px solid #b7eb8f",
                  borderRadius: "8px",
                  marginBottom: "20px",
                }}
              >
                <p
                  style={{
                    color: "#52c41a",
                    margin: 0,
                    fontSize: "14px",
                    lineHeight: "1.5",
                  }}
                >
                  Your password reset link has been sent successfully! Please
                  check your inbox and follow the instructions to reset your
                  password. If you don't see it in your inbox, please check your
                  spam folder.
                </p>
              </div>
              <Form.Item style={{ marginBottom: 0 }}>
                <Link to="/homepage">
                  <Button
                    block
                    loading={loading}
                    type="primary"
                    htmlType="submit"
                    size="large"
                    style={{
                      height: "48px",
                      borderRadius: "8px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    Back to home
                  </Button>
                </Link>
              </Form.Item>
            </>
          ) : resetPasswordState ? (
            <div
              style={{
                padding: "16px",
                backgroundColor: "#fff2f0",
                border: "1px solid #ffccc7",
                borderRadius: "8px",
                marginBottom: "20px",
              }}
            >
              <p
                style={{
                  color: "#ff4d4f",
                  margin: 0,
                  fontSize: "14px",
                  lineHeight: "1.5",
                }}
              >
                The email address you entered is not associated with any
                registered users. Please check it and try again. If the problem
                persists, please contact support.
              </p>
            </div>
          ) : null}
        </div>

        {/* Only show the form if resetPasswordState is not successful */}
        {resetPasswordState !== true && (
          <Form
            form={form}
            name="normal_login"
            layout="vertical"
            style={{ marginTop: "10px" }}
          >
            <Form.Item
              name="email"
              label={
                <span style={{ color: "#333", fontWeight: "500" }}>
                  Email ID
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "Please enter your email ID",
                },
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
              ]}
              style={{ marginBottom: "24px" }}
            >
              <Input
                variant="outlined"
                prefix={<MailOutlined style={{ color: "#666" }} />}
                placeholder="Enter Email ID"
                autoComplete="userName"
                size="large"
                style={{
                  height: "48px",
                  borderRadius: "8px",
                  fontSize: "15px",
                }}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: "16px" }}>
              <Button
                block
                loading={loading}
                type="primary"
                htmlType="submit"
                size="large"
                onClick={HandleSubmit}
                style={{
                  height: "48px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "500",
                  background: "#1890ff",
                  border: "none",
                }}
              >
                Request a reset link
              </Button>
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                block
                type="link"
                size="large"
                onClick={handleToLogin}
                style={{
                  height: "40px",
                  fontSize: "15px",
                  color: "#666",
                  fontWeight: "400",
                }}
              >
                Back to login
              </Button>
            </Form.Item>
          </Form>
        )}
      </Card>
    </div>
  );
}

export default ForgotPassword;
